import { styled } from '@mui/material'

export const ChatBG = styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.05;
  background-image: url('/assets/svg/chat-bg.svg');
  background-repeat: repeat;
`
